import { rem } from 'polished'
import styled from 'styled-components'

import media from '../../util/media'

export const AwardsWrapper = styled.div``

export const AwardsList = styled.ul`
  display: flex;
  flex-direction: column;
`

export const AwardsItem = styled.li`
  position: relative;
  display: flex;

  &:before {
    content: '*';
    font-size: ${rem(30)};
    font-family: ${({ theme }) => theme.font[1]};
    color: ${({ theme }) => theme.colors.primary};
    margin-right: 6px;
    margin-top: 3px;
  }

  &:not(:last-of-type) {
    margin-bottom: 10px;
  }
`

export const AwardsText = styled.p`
  font-size: ${rem(13)};
  line-height: 1.3;
`
